import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import {
  Typography,
  Grid,
  Card,
  CardContent,
  SelectField,
  Option,
  Accordion,
  AccordionItem,
  AccordionSummary,
  AccordionTitle,
  AccordionDetails,
  Tabs,
  Tab,
  TabPanel,
  TabPanels,
  TabList,
  Dropdown,
  DropdownButton,
  DropdownMenu,
  DropdownItem,
  IconButton,
  Switch,
  FormControlLabel,
  Tooltip,
  TextField,
  Button
} from "@deere/fuel-react";
import SelfServiceButtons from "../SelfServiceButtons";
import { ReactComponent as DeleteIcon } from "@deere/ux.brand-foundations/icons/delete.svg";
import DetailsTab from "../tabs/QuestionStep.Details";
import SelectionsTab from "../tabs/QuestionStep.Selections";
import DependencyTab from "../tabs/QuestionStep.Dependencies";
import TranslationsTab from "../tabs/QuestionStep.Translations";
import HelpTextTranslationsTab from "../tabs/QuestionStep.HelpText.Translations";
import SelectionsTranslationsTab from "../tabs/QuestionStep.Selections.Translations";
import { SELF_SERVICE_QUE_TYPES_GENERIC, SELF_SERVICE_QUE_TYPES_PART, SELFSERVICE_FIELD_NAMES, DEFAULT_PART_COLUMN, SURVEYPART_SECTION_TYPES, TOOLTIP_TRANSLATION_LABEL, NO_INFO, QUESTION_TYPES, LBL_ERROR, DEFAULT_PART_COLUMNS, MAX_ADDITIONAL_COLS } from "../../../../utils/surveyLiterals";
import { validateQuestionStep } from "../../../../utils/validation";
import QuestionLinksTab from "../tabs/QuestionStep.Links";
import { DndContext } from "@dnd-kit/core";
import Droppable from "../utils.js/Droppable";
import { ERR_ADD_CNTRY_QUE, ERR_DEPENDENCY_REORDER, ERR_EXISTING_COL } from "../../../../utils/errorLiterals";
import { GenericFuelModal } from "../../../../components/modals/GenericFuelModal";

const QuestionStep = ({questionStepError, setQuestionStepError, currentStep, activeStep, setActiveStep, payloadData, setPayloadData, setShowDraftSuccess, languageList }) => {
  const { t } = useTranslation();
  const [selectedSec, setSelectedSec] = useState("");
  const [questions, setQuestions] = useState([]);
  const section = payloadData.sections.find((sec) => sec.code === selectedSec);
  const [isPartSection, setIsPartSection] = useState(false);
  const [showReorderFeature, setShowReorderFeature] = useState(false);
  const [showQueTypeError, setShowQueTypeError] = useState(false);
  const [additionalColumn, setAdditionalColumn] = useState("");
  const [existingColError, setExistingColError] = useState(false);
  const selfServiceQueTypes = section && section.type === SURVEYPART_SECTION_TYPES.PART ? SELF_SERVICE_QUE_TYPES_PART : SELF_SERVICE_QUE_TYPES_GENERIC;


  useEffect(() => {
    if (selectedSec && payloadData) {
      const questions = [...section.questions];
      questions.forEach((que) => {
        const index = selfServiceQueTypes.findIndex((type) => type.code === que.type);
        if (index > -1) {
          que.typeText = selfServiceQueTypes[index].type;
          que.needSelections = selfServiceQueTypes[index].needSelections;  
        }
      });
      setQuestions(questions);
    }
  }, [selectedSec, payloadData.sections]);

  const addQueHandler = (quesType) => {
    let isQueTypeError = true;
    if (quesType.code === QUESTION_TYPES.SEL_STATE) { //Is the question being added a state selector
      const arrQueSelCntry = questions.filter((que) => que.type === QUESTION_TYPES.SEL_CNTRY);
      const arrQueSelState = questions.filter((que) => que.type === QUESTION_TYPES.SEL_STATE);
      if (arrQueSelCntry.length > 0) { //There should be atleast 1 country selector already added
        for (let i=0; i<arrQueSelCntry.length; i++) { //Checking if there is atleast 1 country selector which is not already mapped to a state selector
          const index = arrQueSelState.findIndex((que) => que.codeQuestionDepends === arrQueSelCntry[i].code);
          if (index === -1) {
            isQueTypeError = false;
            break;
          }
        }
      }
    } else isQueTypeError = false;
    if (isQueTypeError) setShowQueTypeError(true);
    else {
      let objNewQuestion = {
        type: quesType.code,
        active: true,
        idSelectionDependson: 0,
        idQuestionDepends: 0,
        codeQuestionDepends: null, 
        idQuestionParent: 0,
        selections: [],
        defaultColumns: [],
        text: "",
        showOrder: 0,
        code: "",
        required: false,
        translations: [],
        questionsGroup: 0,
        html: false,
        links: [],
        typeText: quesType.type, //Additional Property for UI //Won't be saved in DB
        needSelections: quesType.needSelections, //Additional Property for UI //Won't be saved in DB
        helpText: "",
      };
      setPayloadData((prevState) => {
        const sectionIndex = prevState.sections.findIndex((section) => section.code === selectedSec);
        const newSections = [...prevState.sections];
        const questionCount = newSections[sectionIndex].questions.length + 1;
        objNewQuestion.showOrder = questionCount;
        objNewQuestion.code = newSections[sectionIndex].code + "_Q" + questionCount;
        const newQuestions = [...newSections[sectionIndex].questions, objNewQuestion];
        newSections[sectionIndex] = { ...newSections[sectionIndex], questions: newQuestions };
        return { ...prevState, sections: newSections };
      });
    }
  };

  const handleSectionSelection =(event) => {
    payloadData.sections.every((section)=>{
      if(section.type===SURVEYPART_SECTION_TYPES.PART && section.code===event.target.value){
        setIsPartSection(true);
        return false;
      }else{
        setIsPartSection(false);
        return true;
      }
    })
    setSelectedSec(event.target.value);
  }

  const changeHandler = (e, code) => {
    setQuestionStepError({ show: false, message: "" });
    setPayloadData((prevState) => {
      const sectionIndex = prevState.sections.findIndex((section) => section.code === selectedSec);
      const newSections = [...prevState.sections];
      
      const newQuestions = [...newSections[sectionIndex].questions];
      const questionIndex = newQuestions.findIndex((que) => que.code === code);
      switch (e.target.name) {
        case SELFSERVICE_FIELD_NAMES.label:
          newSections[sectionIndex].questions[questionIndex].text = e.target.value;
          break;
        case SELFSERVICE_FIELD_NAMES.tooltip:
          newSections[sectionIndex].questions[questionIndex].helpText = e.target.value;
          break;
        case SELFSERVICE_FIELD_NAMES.questionsGroup:
          newSections[sectionIndex].questions[questionIndex].questionsGroup = e.target.value && e.target.value !== "" ? parseInt(e.target.value) : 0;
          break;
        case SELFSERVICE_FIELD_NAMES.required:
          newSections[sectionIndex].questions[questionIndex].required = e.target.checked;
          break;
        case SELFSERVICE_FIELD_NAMES.codeQuestionDepends:
          newSections[sectionIndex].questions[questionIndex].codeQuestionDepends = e.target.value;
          newSections[sectionIndex].questions[questionIndex].idSelectionDependson = 0;
          break;
        case SELFSERVICE_FIELD_NAMES.idSelectionDependson:
          newSections[sectionIndex].questions[questionIndex].idSelectionDependson = e.target.value ? parseInt(e.target.value) : 0;
          break;
      }
      return { ...prevState, sections: newSections };
    });
  };

  const queDeleteHandler = (que) => {
    setPayloadData((prevState) => {
      const sectionIndex = prevState.sections.findIndex((section) => section.code === selectedSec);
      const newSections = [...prevState.sections];
      const newQuestions = [...newSections[sectionIndex].questions];
      const index = newQuestions.findIndex((nq) => nq.code === que.code);
      if (index > -1) newQuestions.splice(index, 1);
      newQuestions.forEach((nq) => {
        if (nq.showOrder > que.showOrder) {
          const newCount = nq.showOrder - 1;
          nq.showOrder = newCount;
          nq.code = nq.code.split("_Q")[0] + "_Q" + newCount;
        }
      });
      newSections[sectionIndex] = { ...newSections[sectionIndex], questions: newQuestions };
      return { ...prevState, sections: newSections };
    });
  };

  const fnValidate = () => {
    const error = validateQuestionStep(payloadData);
    error.show
    ? setQuestionStepError(error)
    : setActiveStep((prevState) => {
        return prevState + 1;
      });
  };

  const calculateNewIndex = (activeIndex, overIndex, index) => {
    if (activeIndex < overIndex) {
      return index < activeIndex ? index + 1 :
             index === activeIndex ? overIndex + 1 :
             index <= overIndex ? index :
             index + 1;
    } else { // activeIndex > overIndex
      return index < activeIndex ? (index < overIndex ? index + 1 : index + 2) :
             index === activeIndex ? overIndex + 1 :
             index + 1;
    }
  }

  const handleDragEnd = ({ active, over }) => {
    setQuestionStepError({ show: false, message: "" });
    if (!over) {
      return;
    }
    if (active.id !== over.id) {
      const activeIndex = active.data.current.sortable.index;
      const overIndex = over.data.current?.sortable.index || 0;
      const arrItems = active.data.current.sortable.items;
      const arrNewShowOrder = arrItems.map((item, index) => {
        return { queCode: item, showOrder: calculateNewIndex(activeIndex, overIndex, index) };
      });
      let isDependencyError = false;
      for (let i=0; i<questions.length; i++) {
        if (questions[i].codeQuestionDepends && questions[i].codeQuestionDepends !== "") {
          const queShowOrderIdx = arrNewShowOrder.findIndex((item) => questions[i].code === item.queCode);
          const parentShowOrderIdx = arrNewShowOrder.findIndex((item) => questions[i].codeQuestionDepends === item.queCode);
          if (queShowOrderIdx > -1 && parentShowOrderIdx > -1 && arrNewShowOrder[parentShowOrderIdx].showOrder > arrNewShowOrder[queShowOrderIdx].showOrder) {
            isDependencyError = true;
            break;
          }
        }
      }
      if (isDependencyError) setQuestionStepError({ show: true, message: ERR_DEPENDENCY_REORDER });
      else
        setPayloadData((prevState) => {
          const sectionIndex = prevState.sections.findIndex((section) => section.code === selectedSec);
          const newSections = [...prevState.sections];
          let newQuestions = [...newSections[sectionIndex].questions];
          newQuestions.forEach((que) => {
            const index = arrNewShowOrder.findIndex((item) => item.queCode === que.code);
            que.showOrder = arrNewShowOrder[index].showOrder;
          });
          newSections[sectionIndex].questions = newQuestions;
          return { ...prevState, sections: newSections };
        });
    }
  };

  const addNewhandler = () => {
        const deereColumns = payloadData.defaultColumns.map((col) => col.columnNames);
        if (deereColumns.includes(additionalColumn)) {
          setExistingColError(true);
        } else {
          setPayloadData((prevState) => {
            const newDefaultColumns = [...prevState.defaultColumns];
            const additionallyAddedColumns = newDefaultColumns.filter((col) => !DEFAULT_PART_COLUMNS.includes(col.columnNames));
            const colNumber = additionallyAddedColumns.length === 0 ? "1" : "2";
            newDefaultColumns.push({ columnNames: additionalColumn, isNonDeere: false, defaultColumnMapping: `additional_column_${colNumber}` });
            newDefaultColumns.push({ columnNames: additionalColumn, isNonDeere: true, defaultColumnMapping: `additional_column_${colNumber}` });
            return { ...prevState, defaultColumns: newDefaultColumns };
          });
        }
        setAdditionalColumn("");
      }; 

    const isDisableNewCol = () => {
      if (payloadData && payloadData.defaultColumns) {
        const additionallyAddedColumns = payloadData.defaultColumns.filter((col) => !DEFAULT_PART_COLUMNS.includes(col.columnNames));
        return additionallyAddedColumns.length === MAX_ADDITIONAL_COLS*2; //Each additional column is added for both NonDeere and Deere
      }
      return true;
    };
    
    const showDeleteIcon = (colName) => {
      const additionallyAddedColumns = payloadData.defaultColumns.filter((col) => !DEFAULT_PART_COLUMNS.includes(col.columnNames));
      const index = additionallyAddedColumns.findIndex((col) => col.columnNames === colName);
      return index > -1;
    }

    const deleteAdditionalColumn = (colName) => {
      setPayloadData((prevState) => {
        const newDefaultColumns = prevState.defaultColumns.filter((col) => col.columnNames !== colName);
        return { ...prevState, defaultColumns: newDefaultColumns };
      });
    }

  return (
    <Card>
      <CardContent>
        <Typography variant="h1" mb={4}>
          {currentStep.step} - {currentStep.title}
        </Typography>
        <SelectField
          label="Select your section"
          value={selectedSec}
          onChange={(event) => {
            setQuestionStepError({ show: false, message: "" });
            handleSectionSelection(event);
          }}
        >
          <Option disabled hidden value="">
            {t("lbl_dropdown_select")}
          </Option>
          {payloadData &&
            payloadData.sections &&
            payloadData.sections.sort((a, b) => (a.showOrder > b.showOrder ? 1 : -1)).map((sec) => (
              <Option key={sec.code} value={sec.code} disabled={sec.type === SURVEYPART_SECTION_TYPES.SUPPLIER || sec.type === SURVEYPART_SECTION_TYPES.RESPONSES}>
                {sec.description}
              </Option>
            ))}
        </SelectField>
        {isPartSection && (
          <Grid container direction="column">
            <Grid item>
              <Typography size="sm" fontWeight={600} mt={4}>{DEFAULT_PART_COLUMN}</Typography>
            </Grid>
            <Grid item display="flex">
              {payloadData.defaultColumns && payloadData.defaultColumns.filter((column) => !column.isNonDeere).map((column, index) => (
                <div key={index} style={{ display: "flex", alignItems: "center", marginLeft: "15px" }}>
                  <Typography size="sm" title={column.columnNames}>{`${index + 1}.${column.columnNames}`}</Typography>
                  {showDeleteIcon(column.columnNames) && (
                    <DeleteIcon
                      title="Delete"
                      height={18}
                      width={18}
                      style={{ cursor: "pointer", marginLeft: "8px" }}
                      onClick={() => deleteAdditionalColumn(column.columnNames)}
                    />
                  )}
                </div>
              ))}
            </Grid>
            <Grid item container spacing={2} mt={2}>
              <Grid item xs={4}>
                <TextField
                    placeholder={"Enter additional column here..."}
                    onChange={(e) => {
                      setExistingColError(false);
                      setAdditionalColumn(e.target.value);
                    }}
                    value={additionalColumn}
                    disabled={isDisableNewCol()}
                  />
                </Grid>
              <Grid item xs={1}>
                <Button onClick={addNewhandler} disabled={additionalColumn === "" || isDisableNewCol()}>Add</Button>
              </Grid>
              <Grid item xs={3}>
                {existingColError && <Typography variant="subtitle1" color="#C21020">{ERR_EXISTING_COL}</Typography>}
              </Grid>
            </Grid>
          </Grid>
        )}
        <Grid container justifyContent="space-between" mt={4}>
          <FormControlLabel control={<Switch onChange={(e) => setShowReorderFeature(e.target.checked)} disabled={!selectedSec} />} label="Reorder Questions" />
          <Dropdown>
            <DropdownButton disabled={!selectedSec}>Add New Question</DropdownButton>
            <DropdownMenu>
              {selfServiceQueTypes.map((types) => (
                 <Tooltip title={types.helpText || NO_INFO} arrow>
                <DropdownItem key={types.code} onClick={() => addQueHandler(types)}>
                  {types.type}
                </DropdownItem>
                </Tooltip>
              ))}
            </DropdownMenu>
          </Dropdown>
        </Grid>
        {showReorderFeature ? (
          <DndContext onDragEnd={handleDragEnd}>
            <Droppable id="questions" questions={questions} />
          </DndContext>
        ) : (
          <Accordion dense mt={4} mb={4}>
            {questions
              .sort((a, b) => (a.showOrder > b.showOrder ? 1 : -1))
              .map((que) => (
                <AccordionItem key={que.code}>
                  <Grid container>
                    <Grid item xs={11}>
                      <AccordionSummary>
                        <AccordionTitle>{que.text ? `${que.showOrder}. ${que.text}` : `${que.showOrder}`}</AccordionTitle>
                      </AccordionSummary>
                    </Grid>
                    <Grid item xs={1} textAlign="center" alignContent="center">
                      <IconButton onClick={() => queDeleteHandler(que)}>
                        <DeleteIcon />
                      </IconButton>
                    </Grid>
                  </Grid>
                  <AccordionDetails>
                    <Tabs>
                      <TabList>
                        <Tab label="Details" />
                        {que.needSelections && <Tab label="Selections" />}
                        <Tab label="Dependency" />
                        <Tab label="Links" />
                        {payloadData.language && payloadData.language.length > 1 && <Tab label="Translations" />}
                        {payloadData.language && payloadData.language.length > 1  && <Tab label={TOOLTIP_TRANSLATION_LABEL} />}
                    </TabList>
                      <TabPanels>
                        <TabPanel>
                          <DetailsTab changeHandler={changeHandler} que={que} isPartSection={isPartSection}/>
                        </TabPanel>
                        {que.needSelections && (
                          <TabPanel style={{ marginTop: "20px" }}>
                            <Tabs>
                              <TabList style={{ height: "50px" }}>
                                <Tab label="Selections Details" />
                                {payloadData.language && payloadData.language.length > 1 && <Tab label="Selections Translations" />}
                              </TabList>
                              <TabPanels>
                                <TabPanel>
                                  <SelectionsTab setError={setQuestionStepError} setPayloadData={setPayloadData} payloadData={payloadData} selectedSec={selectedSec} que={que} />
                                </TabPanel>
                                <TabPanel>
                                  {payloadData.language && payloadData.language.length > 1  && (
                                    <SelectionsTranslationsTab
                                      payloadData={payloadData}
                                      setPayloadData={setPayloadData}
                                      selectedSec={selectedSec}
                                      que={que}
                                      payloadLanguages={payloadData.language}
                                      languageList={languageList}
                                    />
                                  )}
                                </TabPanel>
                              </TabPanels>
                            </Tabs>
                          </TabPanel>
                        )}
                        <TabPanel>
                          <DependencyTab payloadData={payloadData} selectedSec={selectedSec} selectedQue={que} changeHandler={changeHandler} />
                        </TabPanel>
                        <TabPanel>
                          <QuestionLinksTab section={section} selectedSec={selectedSec} selectedQue={que} payloadData={payloadData} setPayloadData={setPayloadData} />
                        </TabPanel>
                      {payloadData.language && payloadData.language.length > 1 && (
                        <TabPanel>
                          <TranslationsTab payloadData={payloadData} setPayloadData={setPayloadData} selectedSec={selectedSec} que={que} languageList={languageList} />
                        </TabPanel>
                      )}
                      {payloadData.language && payloadData.language.length > 1  && (
                        <TabPanel>
                          <HelpTextTranslationsTab payloadData={payloadData} setPayloadData={setPayloadData} selectedSec={selectedSec} que={que} languageList={languageList} />
                        </TabPanel>
                      )}
                    </TabPanels>
                  </Tabs>
                </AccordionDetails>
              </AccordionItem>
            ))}
        </Accordion>
        )}
        {questionStepError.show && (
          <Typography variant="subtitle1" color="#C21020" textAlign="right" mb={2}>
            {questionStepError.message}
          </Typography>
        )}
        <Grid container justifyContent="flex-end">
          <SelfServiceButtons activeStep={activeStep} setActiveStep={setActiveStep} fnValidate={fnValidate} payloadData={payloadData} setPayloadData={setPayloadData} setShowDraftSuccess={setShowDraftSuccess} />
        </Grid>
      </CardContent>
      <GenericFuelModal title={LBL_ERROR} message={ERR_ADD_CNTRY_QUE} show={showQueTypeError} handleClose={() => setShowQueTypeError(false)} handleSave={() => setShowQueTypeError(false)} />
    </Card>
  );
};

export default QuestionStep;
